import * as React from 'react';

// Utils
import { isWebBridgeSupported, useTranslation } from '@shopee-user/platform';

// HOC
import { withUserWebView } from '@shopee-user/with-web-view';

// Components
import { AccessibleSpan } from '@shopee-user/shared-customization-ui';

// Constants
import { constants } from '@shopee-user/spx-customization-logic';
import { config } from '@shopee-user/platform';

// Types
import { WithUserWebViewProps } from '@shopee-user/with-web-view';

// Styles
import styles from './style.scss';

type Props = WithUserWebViewProps;

function LoginTermsOfService({ webViewNavigateToUrl }: Props) {
  const I18n = useTranslation();

  return (
    <div className={styles.container}>
      {I18n.tNode('msg_auth_login_i_agree_to_terms', {
        context: config.BUSINESS_TARGET,
        terms_of_service: (
          <AccessibleSpan
            className={styles.link}
            role="link"
            onClick={() => {
              const termsOfServiceLink = isWebBridgeSupported()
                ? constants.TERMS_OF_SERVICE_WEBVIEW_LINK
                : constants.TERMS_OF_SERVICE_LINK;
              webViewNavigateToUrl(termsOfServiceLink);
            }}
          >
            {I18n.t('msg_auth_terms_of_service')}
          </AccessibleSpan>
        ),
        privacy_policy: (
          <AccessibleSpan
            className={styles.link}
            role="link"
            onClick={() => {
              const privacyPolicyLink = isWebBridgeSupported()
                ? constants.PRIVACY_POLICY_WEBVIEW_LINK
                : constants.PRIVACY_POLICY_LINK;
              webViewNavigateToUrl(privacyPolicyLink);
            }}
          >
            {I18n.t('msg_auth_privacy_policy')}
          </AccessibleSpan>
        ),
      })}
    </div>
  );
}
export default withUserWebView({})(LoginTermsOfService);
